import { createScreens } from "react-native-ridge-navigation";

import routes from "./NavigatorRoutes";

export const BottomRoots = {
  Home: {
    path: "/home",
    title: () => "Home",
    icon: require("./assets/img/home/icon-20.png"),
    selectedIcon: require("./assets/img/home-active/icon-20.png"),
    child: routes.HomeScreen,
  },
  AboutUs: {
    path: "/over-ons",
    title: () => "Over ons",
    icon: require("./assets/img/home/icon-20.png"),
    selectedIcon: require("./assets/img/home-active/icon-20.png"),
    child: routes.AboutScreen,
  },
  Webshop: {
    path: "/webwinkel",
    title: () => "Over ons",
    icon: require("./assets/img/home/icon-20.png"),
    selectedIcon: require("./assets/img/home-active/icon-20.png"),
    child: routes.WebshopScreen,
  },
  Contact: {
    path: "/contact",
    title: () => "Contact",
    icon: require("./assets/img/home/icon-20.png"),
    selectedIcon: require("./assets/img/home-active/icon-20.png"),
    child: routes.ContactScreen,
  },
  Products: {
    path: "/boodschappen-doen",
    title: () => "Producten",
    icon: require("./assets/img/product/icon-20.png"),
    selectedIcon: require("./assets/img/product-active/icon-20.png"),
    child: routes.CategoryScreen,
  },
  Account: {
    path: "/account",
    title: () => "Account",
    icon: require("./assets/img/account/icon-20.png"),
    selectedIcon: require("./assets/img/account-active/icon-20.png"),
    child: routes.AccountScreen,
  },
  Recipes: {
    path: "/recepten",
    title: () => "Recepten",
    icon: require("./assets/img/recept/icon-20.png"),
    selectedIcon: require("./assets/img/recept-active/icon-20.png"),
    child: routes.RecipesScreen,
  },
  Cart: {
    path: "/mand",
    title: () => "Mand",
    icon: require("./assets/img/cart/icon-20.png"),
    selectedIcon: require("./assets/img/cart-active/icon-20.png"),
    child: routes.CartScreen,
  },
};

export const screens = createScreens(routes);
